import { Injectable } from '@angular/core';
import packageJson from '../../../../package.json';

@Injectable({
    providedIn: 'root',
})
export class TranslationCacheBusterService {
    getVersion(): string {
        return packageJson.version;
    }

    getTranslationUrl(basePath: string, lang: string): string {
        const version = this.getVersion();
        return `${basePath}${lang}.json?v=${version}`;
    }
}
